import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICourse } from '@interfaces/ICourse';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoursesChangesService {
  constructor(private _http: HttpClient) {}

  createCourse(course: ICourse): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/`;
    return this._http.post<ICourse>(url, course);
  }

  updateCourse(id: number, course: ICourse): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.put<ICourse>(url, course);
  }

  delete(id: number): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.delete<{ detail: string }>(url);
  }

  deactivateCourse(id: number): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.patch<ICourse>(url, { is_active: false });
  }

  activate(id: number): Observable<ICourse> {
    const url = `${environment.baseUrl}api/v1/courses/${id}/`;
    return this._http.patch<ICourse>(url, { is_active: true });
  }
}
